import SellOrderDeliveryWarning from './SellOrderDeliveryWarning'

export default SellOrderDeliveryWarning
